// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"34dce074","952":"386ef852"}[chunkId] + ".chunk.js";
};